// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__iPl3Y","productName":"Table_productName__Hxj7k"};